// frontend/src/pages/admin/cre/hooks/useCreUpdates.js
import { useCallback, useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { creClient } from '../api/creClient';

export function useCreUpdates() {
  const [proposals, setProposals] = useState([]);
  const [delibs, setDelibs] = useState([]);
  const [loading, setLoading] = useState(false);

  const refetch = useCallback(async () => {
    setLoading(true);
    const [pRes, dRes] = await Promise.allSettled([
      creClient.listProposals('pending'),
      creClient.listDeliberations(),
    ]);
    if (pRes.status === 'fulfilled') setProposals(pRes.value);
    else toast.error(`Propositions: ${pRes.reason?.response?.data?.message || pRes.reason?.message || 'erreur'}`);
    if (dRes.status === 'fulfilled') setDelibs(dRes.value);
    else toast.error(`Délibérations: ${dRes.reason?.response?.data?.message || dRes.reason?.message || 'erreur'}`);
    setLoading(false);
  }, []);

  const approve = useCallback(async (id) => {
    const t = toast.loading('Application…');
    try { await creClient.approve(id); toast.success('Appliqué', { id: t }); await refetch(); }
    catch (e) { toast.error(`Erreur: ${e.response?.data?.message || e.message}`, { id: t }); }
  }, [refetch]);

  const reject = useCallback(async (id) => {
    try { await creClient.reject(id); toast.success('Rejeté'); await refetch(); }
    catch (e) { toast.error(`Erreur: ${e.message}`); }
  }, [refetch]);

  const runNow = useCallback(async () => {
    const t = toast.loading('Lancement agent CRE…');
    try {
      const r = await creClient.runNow();
      toast.success(r.message, { id: t, duration: 6000 });

      // Polling 5s × 18 = 90s max pour détecter les nouvelles propositions
      const startedAt = Date.now();
      const initialCount = proposals.length;
      const poll = setInterval(async () => {
        if (Date.now() - startedAt > 90_000) { clearInterval(poll); return; }
        try {
          const newP = await creClient.listProposals('pending');
          if (newP.length !== initialCount) {
            setProposals(newP);
            const newD = await creClient.listDeliberations();
            setDelibs(newD);
            toast.success(`${newP.length - initialCount} nouvelle(s) proposition(s) détectée(s)`, { duration: 5000 });
            clearInterval(poll);
          }
        } catch (_) { /* ignore polling errors */ }
      }, 5_000);
    } catch (e) {
      // Gestion 409 Conflict (run déjà en cours)
      const status = e.response?.status;
      const msg = e.response?.data?.message || e.message;
      if (status === 409) {
        toast.error(`Conflit : ${msg}`, { id: t, duration: 6000 });
      } else {
        toast.error(`Erreur: ${msg}`, { id: t });
      }
    }
  }, [proposals.length]);

  useEffect(() => { refetch(); }, [refetch]);
  return { proposals, delibs, loading, refetch, approve, reject, runNow };
}
